import { __awaiter, __decorate, __rest } from "tslib";
import { singleton } from 'mana-syringe';
import { DisposableCollection, Disposable, XFlowEdgeCommands, XFlowNodeCommands, } from '@antv/xflow-core';
import { IHookContribution } from '@antv/xflow-core';
import { NsAddEdgeEvent } from '../../config-graph';
import { getProps } from '../../utils';
/**
 * 内置的hook contribution
 * 处理 config上的runtime的注册项
 */
let FlowHooksContribution = class FlowHooksContribution {
    constructor() {
        this.toDispose = new DisposableCollection();
        this.registerHookHub = () => __awaiter(this, void 0, void 0, function* () {
            return Disposable.create(() => { });
        });
        this.registerHook = (hooks) => __awaiter(this, void 0, void 0, function* () {
            const toDispose = new DisposableCollection();
            const disposables = [
                hooks.afterGraphInit.registerHook({
                    name: 'call add edge to replace temp edge',
                    handler: (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                        const { commandService, graph } = handlerArgs;
                        graph.on(NsAddEdgeEvent.EVENT_NAME, (args) => __awaiter(this, void 0, void 0, function* () {
                            const { edge } = args, edgeConfig = __rest(args, ["edge"]);
                            const { tempEdgeId } = edgeConfig, rest = __rest(edgeConfig, ["tempEdgeId"]);
                            const config = {
                                edgeConfig: Object.assign(Object.assign({}, rest), { 
                                    // renderKey: FLOWCHART_EDGE, // 暂不支持
                                    source: {
                                        cell: edgeConfig.source,
                                        port: edgeConfig.sourcePortId,
                                    }, target: {
                                        cell: edgeConfig.target,
                                        port: edgeConfig.targetPortId,
                                    }, zIndex: 1, attrs: {
                                        line: {
                                            stroke: '#A2B1C3',
                                            targetMarker: {
                                                name: 'block',
                                                width: 12,
                                                height: 8,
                                            },
                                            strokeDasharray: '5 5',
                                            strokeWidth: 1,
                                        },
                                    }, data: Object.assign({}, rest) }),
                            };
                            yield commandService.executeCommand(XFlowEdgeCommands.ADD_EDGE.id, config);
                            /** 删除 createEdge() 产生的 tempEdge */
                            yield commandService.executeCommand(XFlowEdgeCommands.DEL_EDGE.id, {
                                edgeConfig: {
                                    id: tempEdgeId,
                                },
                            });
                            /**
                             * 新增边时更新入边、出边信息
                             * @link https://github.com/ant-design/ant-design-charts/issues/1189
                             */
                            const sourceNode = graph.getCellById(edgeConfig.source);
                            const targetNode = graph.getCellById(edgeConfig.target);
                            yield commandService.executeCommand(XFlowNodeCommands.UPDATE_NODE.id, {
                                nodeConfig: Object.assign(Object.assign({}, sourceNode.data), { incomingEdges: graph.getIncomingEdges(sourceNode), outgoingEdges: graph.getOutgoingEdges(sourceNode) }),
                            });
                            yield commandService.executeCommand(XFlowNodeCommands.UPDATE_NODE.id, {
                                nodeConfig: Object.assign(Object.assign({}, targetNode.data), { incomingEdges: graph.getIncomingEdges(targetNode), outgoingEdges: graph.getOutgoingEdges(targetNode) }),
                            });
                            const onAddEdge = getProps('onAddEdge');
                            if (typeof onAddEdge === 'function') {
                                onAddEdge(config.edgeConfig);
                            }
                            args.edge.remove();
                        }));
                    }),
                }),
            ];
            toDispose.pushAll(disposables);
            return Disposable.create(() => { });
        });
    }
};
FlowHooksContribution = __decorate([
    singleton({ contrib: IHookContribution })
], FlowHooksContribution);
export { FlowHooksContribution };
//# sourceMappingURL=flow.js.map